<style lang="scss">
    .main-box{
        background: #ffffff;
        min-height:600px;
    }
    .page-title {

        padding: 20px 40px 5px 40px;
        border-bottom:1px #d8d9df solid ;
        h2 {
            font-family: microsoft yahei;
            font-size:24px;
            color:#333333;
            font-weight: normal;
            float:left;
            line-height:55px;

        }
        .guangfa{
            width:220px;
            float:right;
            text-align:center;
            img{width:166px;height:40px;}
            span{
                font-size:12px;
                color:#c2c4ca;
                display: block;
            }
        }
        .payCenter{
            float: left;
            width: 166px;
            text-align: center;
            font-family: microsoft yahei;
            color: #333333;
            font-size: 24px;
            line-height: 50px;
        }
    }
    .guide-box{
        .pic-guide{
            div{
                float:left
            }
            text-align: center;
            margin:80px 180px;
        }
        .success-wrap ,.wx-wrap,.error-wrap{
            img{
                width: 103px;
                height: 78px;
                float: left;
            }
            .success-wrap-con,.wx-wrap-con,.error-wrap-con{
                margin-left:10px;
                text-align: left;
                h2{
                    color:#666666;
                    font-size:24px;
                    font-weight: normal;
                    margin-bottom: 10px;
                }
                p,div{
                    font-size:16px;
                    color:#666666;
                }
                div{
                    margin-top:10px;
                }
            }

        }
        .wx-wrap{
            img{
                width: 107px;
            }
        }
        .buttom{
            margin-bottom:102px;
        }
        router-link{
            color:#64b2d0;
            text-decoration: underline;
        }
    }
</style>


<template>
  <Layout>
   <div class="main-box">
       <div class="page-title clearfix">
           <div class="payCenter">支付中心</div>
           <div class="guangfa"><img src="../../assets/images/guangfa.png" alt=""> <span>宜人贷与广发银行合作网贷资金存管业务</span></div>
       </div>
       <div class="guide-box">
           <div class="pic-guide clearfix">
               <div class="success-wrap" v-if="$route.query.state == '02'">
                   <img src="../../assets/result/success.png" alt="">
                   <div class="success-wrap-con">
                       <h2>支付成功</h2>
                       <p>很抱歉，系统出错了，还款业务未完成，支付金额已充值到账中心</p>
                       <p>如果您有任何疑问，请致电400-811-2288</p>
                       <div class="buttom">您现在可以：<router-link :to="{name:'account'}">查看我的账户</router-link></div>
                   </div>
               </div>
               <div class="error-wrap" v-else>
                   <img src="../../assets/result/error.png" alt="">
                   <div class="error-wrap-con">
                       <h2>支付失败</h2>
                       <p>如果您有任何疑问，请致电400-811-2288</p>
                       <div class="buttom">您现在可以：<router-link :to="{name:'account'}">查看我的账户</router-link></div>

                       <!--<div class="buttom">您现在可以:<router-link :to="{name:'repayment'}">重试还款</router-link></div>-->
                   </div>
               </div>
               <div class="wx-wrap">
                   <img src="../../assets/result/success.png" alt="">
                   <div class="wx-wrap-con">
                       <h2>微信还款</h2>
                       <p>您还可以选择微信还款方式</p>
                       <p>扫码关注宜人贷官方微信公众号</p>
                   </div>
               </div>
           </div>
       </div>
   </div>

  </Layout>
</template>
<script>
	import Layout from '../layouts/main'


	export default {
		data(){
			return {}
        },
		components: { Layout }
	}
</script>
